"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadCrumb = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
;
;
var BreadCrumb = function (_a) {
    var crumb = _a.crumb, _b = _a.routing, routing = _b === void 0 ? false : _b, _c = _a.customClasses, customClasses = _c === void 0 ? "" : _c;
    return (react_1.default.createElement(react_1.default.Fragment, null, routing ? (react_1.default.createElement(react_router_dom_1.Link, { to: crumb.url, className: customClasses },
        react_1.default.createElement("span", null, crumb.title))) : (react_1.default.createElement("a", { href: crumb.url, className: customClasses },
        react_1.default.createElement("span", null, crumb.title)))));
};
exports.BreadCrumb = BreadCrumb;
